import stCss from '../../st-css';
import {styleProps, textShorthandProps} from 'st-css';
import { spacingShorthandProps, sizeShorthandProps, visibilityShorthandProps } from 'st-css';

export const Content = stCss.canonize('div')({position: 'relative'}, styleProps(textShorthandProps, spacingShorthandProps, visibilityShorthandProps, sizeShorthandProps));